var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagPop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 17h62v38H5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M5 30h62v12H5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e50a0",
    d: "M5 17h62v13H5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7bd8",
    d: "M20 18h4v4h-4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3083e8",
    d: "M24 18h20v4H24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3082e7",
    d: "M44 18h4v4h-4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7ad6",
    d: "M48 18h4v4h-4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f7fe0",
    d: "M20 22h4v4h-4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#131313",
    d: "M24 22h4v4h-4z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#121111",
    d: "M28 22h4v4h-4z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1919",
    d: "M32 22h4v4h-4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7ddd",
    d: "M36 22h4v4h-4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#191818",
    d: "M40 22h4v4h-4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#282727",
    d: "M44 22h4v4h-4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#3080e1",
    d: "M48 22h4v4h-4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#3790fd",
    d: "M20 26h4v4h-4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7ddd",
    d: "M24 26h4v4h-4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d79d6",
    d: "M28 26h4v4h-4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#131313",
    d: "M32 26h4v4h-4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3183e8",
    d: "M36 26h4v4h-4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#3489f1",
    d: "M40 26h4v4h-4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f7edf",
    d: "M44 26h4v4h-4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#3690fd",
    d: "M48 26h4v4h-4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M20 30h4v4h-4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#656464",
    d: "M24 30h4v4h-4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M28 30h4v4h-4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#565252",
    d: "M32 30h8v4h-8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#201f1f",
    d: "M40 30h4v4h-4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#5f5e5e",
    d: "M44 30h4v4h-4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#131212",
    d: "M48 30h4v4h-4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    d: "M20 34h4v4h-4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e0e",
    d: "M24 34h4v4h-4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    d: "M28 34h4v4h-4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0d0d",
    d: "M32 34h4v4h-4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#090808",
    d: "M36 34h4v4h-4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#060606",
    d: "M40 34h4v4h-4z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1c1c",
    d: "M44 34h4v4h-4z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#646363",
    d: "M48 34h4v4h-4z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0d0d",
    d: "M20 38h4v4h-4z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "M24 38h4v4h-4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f0f0f",
    d: "M28 38h4v4h-4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e5e5e",
    d: "M32 38h4v4h-4z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M36 38h4v4h-4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d5d5d",
    d: "M40 38h4v4h-4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    d: "M44 38h4v4h-4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#545151",
    d: "M48 38h4v4h-4z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbfbfb",
    d: "M20 42h4v4h-4z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d0c0c",
    d: "M24 42h4v4h-4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#030303",
    d: "M28 42h4v4h-4z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0a0a",
    d: "M32 42h4v4h-4z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#040404",
    d: "M36 42h4v4h-4z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1c1c",
    d: "M40 42h4v4h-4z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f6f6",
    d: "M44 42h4v4h-4z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7d2d2",
    d: "M48 42h4v4h-4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e0e0",
    d: "M20 46h4v4h-4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdfcfc",
    d: "M24 46h4v4h-4z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#dad5d5",
    d: "M28 46h4v4h-4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdfafa",
    d: "M32 46h4v4h-4z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9dfdf",
    d: "M36 46h4v4h-4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf9f9",
    d: "M40 46h4v4h-4z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d5d5",
    d: "M44 46h4v4h-4z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M48 46h4v4h-4z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 17h62v38H5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPop);
export default __webpack_public_path__ + "static/media/flag_pop.4141ec111e2e523c0eed5b2f7a4967f1.svg";
export { ForwardRef as ReactComponent };